import React, { useState, useEffect, useCallback } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { GoogleMapSecretKey } from "../../../../../assets/GlobalVariables";
import { Loader } from "../../../../../Components/Loader/Loader";

// Map container style
const mapContainerStyle = {
  width: "100%",
  height: "40vh",
  minHeight: "300px",
  borderRadius: "10px",
  overflow: "hidden",
};

// Map options
const defaultOptions = {
  disableDefaultUI: false,
  zoomControl: true,
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: true,
  clickableIcons: false,
  gestureHandling: "cooperative",
  maxZoom: 19,
};

const LocationMapView = ({ latitude, longitude }) => {
  // Convert passed coordinates to numbers and handle initial state
  const [mapRef, setMapRef] = useState(null);
  const [searchCoords, setSearchCoords] = useState({
    lat: parseFloat(latitude) || 31.5,
    lng: parseFloat(longitude) || 34.75,
  });

  // Load Google Maps API
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GoogleMapSecretKey,
  });

  // Handle map load
  const onLoad = useCallback((map) => {
    setMapRef(map);
  }, []);

  // Update map when new coordinates are received from parent
  useEffect(() => {
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);
    
    if (!isNaN(lat) && !isNaN(lng)) {
      setSearchCoords({ lat, lng });
      
      // Center map on the new coordinates if map is loaded
      if (mapRef) {
        mapRef.panTo({ lat, lng });
        mapRef.setZoom(15); // Zoom in to the location
      }
    }
  }, [latitude, longitude, mapRef]);

  if (loadError) {
    return (
      <div className="tw-p-4">Unable to load maps. Please try again later.</div>
    );
  }

  return (
    <div className="location-map-container">
      {isLoaded ? (
        <div
          className="map-container tw-rounded-lg tw-w-full tw-overflow-hidden"
        >
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={searchCoords}
            zoom={14}
            onLoad={onLoad}
            options={defaultOptions}
          >
            <Marker
              position={searchCoords}
              animation={window.google?.maps?.Animation.DROP}
            />
          </GoogleMap>
        </div>
      ) : (
        <div className="tw-w-full tw-flex tw-justify-center tw-items-center" style={{ height: "500px" }}>
          <Loader showText />
        </div>
      )}
    </div>
  );
};

export default LocationMapView;